<template lang="pug">
div
  RoleSelect(v-if="loaded")
  div(v-if="allowedRoles.includes(login_user.role)")
    h1 My Intake Task
    b-card.border-0
      b-tabs(lazy)
        b-tab.py-3(title="Active")
          ActiveIntakeList(forUser=true)
        b-tab.py-3(title="Completed")
          CompleteIntakeList(forUser=true)
  div(v-else)
    p.my-4 You're not allowed to view this page as {{login_user.role.replace(/_/g, ' ')}}
</template>

<script>
import RoleSelect from '@/components/roleSelect.vue';
import ActiveIntakeList from '@/components/intake_assessment/active.vue';
import CompleteIntakeList from '@/components/intake_assessment/complete.vue';

export default {
  name: 'MyIntakeTask',
  certaintyMenu(link){
    return {iconType: 'fas', icon: 'tasks', link, description: 'My Intake Task', order:2, roles: ['central_triage_team', 'team_lead', 'admin']}
  },
  components: {
    RoleSelect,
    ActiveIntakeList,
    CompleteIntakeList
  },
  computed: {
    loaded(){
      return this.$store.state.loaded;
    },
    login_user(){
      return this.$store.state.login_user;
    }
  },
  data(){
    return{
      allowedRoles:['admin', 'team_lead', 'central_triage_team'],
    }
  }
}
</script>

<style lang="scss">

</style>